var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIgNeg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 724 725.6",
    style: {
      enableBackground: "new 0 0 724 725.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M718.4,364C724,170.7,562.8,12.7,377.8,5.6C171.6-2.4,5.1,163.6,5.3,362.4C5.6,563.1,167.1,712.9,348,720 C561.8,728.3,725,549.4,718.4,364z M597.6,470.1c-1.5,67.7-59.4,130.6-142.5,128.9c-31.6-0.5-63.2,0-94.8,0c0-0.3,0-0.5,0-0.8 c-34.4,0-68.7,0.3-102.8-0.5c-67.5-1-127.4-57.9-129.4-125.6c-2-72.3-2.3-144.8-0.3-217.1c1.8-69.7,61.7-126.6,131.7-127.4 c71-0.8,142.3-0.8,213.3,0.3c61.4,1,122,58.6,123.8,120C598.9,322,599.2,396.1,597.6,470.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.6,165.3c-37.4-1.5-74.8-0.3-112.2-0.3c0-0.3,0-0.5,0.3-0.5c-36.1,0-72.3,0-108.4,0c-41.2,0-88.9,44.2-89.5,85.2 c-1,74.3-1,148.8,0.3,223.4c0.8,43.5,45,87.9,87.4,88.4c72.3,1,144.8,1,217.1,0c48.3-0.8,90.7-44.5,91.2-92.5 c0.5-70.8,0.5-141.3,0.5-212C561.3,212.3,519.3,167.1,474.6,165.3z M362.9,489.3c-67.2,1.5-125.6-54.6-127.1-122.3 c-1.8-71,53.8-129.6,124.1-131.1c69.2-1.3,127.6,54.3,129.6,123.1C491.5,435.7,427.3,492.3,362.9,489.3z M499.3,254.3 c-14.2,0.8-27.5-12.1-27.8-26.5c-0.3-15.2,11.4-27.3,26.5-27.8c14.4-0.5,27.8,12.1,28,26.3C526.4,240.6,513.7,253.5,499.3,254.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.9,272.7c-49.8-1.5-91.2,38.2-92.2,88.7c-1,48.5,37.7,90.7,83.9,91.5c55.8,1,94.5-35.1,95.8-89.5 C453.6,314.7,414.4,274.3,364.9,272.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIgNeg);
export default __webpack_public_path__ + "static/media/ig-neg.080c765d22cb212f29d8436a89939dc0.svg";
export { ForwardRef as ReactComponent };